var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.showAll || _vm.worker.vacations.length
    ? _c(
        "div",
        {
          staticClass: "worker-row",
          class: {
            "worker-row--multiple": _vm.periodGroups.length > 1,
          },
          attrs: { "data-id": _vm.worker.id },
        },
        [
          _c("div", { staticClass: "worker-row__wrapper" }, [
            _c("div", { staticClass: "worker-row__name" }, [
              _c(
                "div",
                { staticClass: "user" },
                [
                  _vm.worker.photo
                    ? _c(
                        "div",
                        {
                          directives: [{ name: "viewer", rawName: "v-viewer" }],
                          staticClass: "user__pic cursor-pointer",
                        },
                        [
                          _c("img", {
                            attrs: { src: _vm.worker.photo, alt: "" },
                          }),
                        ]
                      )
                    : _c("div", { staticClass: "user__pic" }, [
                        _c("img", { attrs: { src: _vm.placeholder, alt: "" } }),
                      ]),
                  _c(
                    "router-link",
                    {
                      staticClass: "user__name",
                      attrs: {
                        to: {
                          name: "personal-employee-summary",
                          params: { id: _vm.worker.id },
                        },
                      },
                    },
                    [_vm._v(" " + _vm._s(_vm.worker.name) + " ")]
                  ),
                ],
                1
              ),
            ]),
            _c(
              "div",
              { staticClass: "worker-row__periods" },
              [
                _vm.canEdit
                  ? _c(
                      "div",
                      {
                        staticClass: "worker-row__actions",
                        attrs: { "data-worker-id": _vm.worker.id },
                      },
                      _vm._l(_vm.days, function (d, i) {
                        return _c(
                          "div",
                          { key: i, staticClass: "worker-row__action" },
                          [
                            _c("button", {
                              attrs: {
                                type: "button",
                                "data-date": d.date,
                                "data-worker-id": _vm.worker.id,
                                "data-event": "add-period",
                              },
                            }),
                          ]
                        )
                      }),
                      0
                    )
                  : _vm._e(),
                !_vm.periodGroups.length
                  ? _c(
                      "div",
                      { staticClass: "worker-row__period" },
                      _vm._l(_vm.days, function (d, i) {
                        return _c("div", {
                          key: i,
                          staticClass: "worker-row__day",
                          class: { "worker-row__day--off": d.dayOff },
                        })
                      }),
                      0
                    )
                  : _vm._e(),
                _vm._l(_vm.periodGroups, function (periodGroup) {
                  return _c(
                    "div",
                    { key: periodGroup.id, staticClass: "worker-row__period" },
                    _vm._l(_vm.days, function (d, i) {
                      return _c(
                        "div",
                        {
                          key: i,
                          staticClass: "worker-row__day",
                          class: {
                            "worker-row__day--off": d.dayOff,
                          },
                        },
                        [
                          _vm._l(periodGroup.periods, function (period) {
                            return [
                              period.startCell === i
                                ? _c(
                                    "div",
                                    {
                                      key: period.id,
                                      staticClass: "vacation",
                                      class: "vacation-" + period.category,
                                      style: {
                                        width: `calc(${
                                          period.duration * 100 + "%"
                                        } - 1px)`,
                                        "min-width": `calc(${
                                          period.duration * 100 + "%"
                                        } - 1px)`,
                                        color: period.color,
                                      },
                                    },
                                    [
                                      _c("div", {
                                        staticClass: "vacation-border",
                                        attrs: {
                                          "data-period-id": period.id,
                                          "data-worker-id": _vm.worker.id,
                                          "data-event": "edit-period",
                                        },
                                      }),
                                      _c(
                                        "div",
                                        { staticClass: "vacation__wrapper" },
                                        [
                                          period.file
                                            ? [
                                                _c("svg-icon", {
                                                  staticClass: "vacation__file",
                                                  attrs: {
                                                    name: "clip",
                                                    size: 14,
                                                  },
                                                }),
                                              ]
                                            : _vm._e(),
                                          _c(
                                            "span",
                                            { staticClass: "vacation__name" },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    period.category === "sick"
                                                      ? "Больничный"
                                                      : period.name
                                                  ) +
                                                  " "
                                              ),
                                            ]
                                          ),
                                          _c(
                                            "span",
                                            {
                                              staticStyle: {
                                                "white-space": "nowrap",
                                              },
                                            },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "vacation__duration",
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        period.totalDuration
                                                      ) +
                                                      " дн. "
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "vacation__dates",
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(period.from) +
                                                      " – " +
                                                      _vm._s(period.to) +
                                                      " "
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ],
                                        2
                                      ),
                                      _c("div", {
                                        staticClass: "vacation__gradient",
                                      }),
                                    ]
                                  )
                                : _vm._e(),
                            ]
                          }),
                        ],
                        2
                      )
                    }),
                    0
                  )
                }),
              ],
              2
            ),
          ]),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }